module.exports = __webpack_public_path__ + "img/iphone-12-shadow-landscape.2229ff0.png";